// loadingStore.ts
import { create } from 'zustand';
export const useLoadingSpinnerStore = create((set) => ({
    isLoading: false,
    message: null, // 초기 메시지를 null로 설정
    showLoading: (message) => {
        set({
            isLoading: true,
            message: message || null,
        });
    },
    hideLoading: () => {
        set({
            isLoading: false,
            message: null,
        });
    },
}));
export const loadingActions = {
    showLoading: (message) => useLoadingSpinnerStore.getState().showLoading(message),
    hideLoading: () => useLoadingSpinnerStore.getState().hideLoading(),
};
//# sourceMappingURL=useLoadingSpinnerStore.js.map